<template>
  <div>
    <p class="m-b-sm">
      Personal access tokens can <strong>read</strong> your team's data, unless the coach who created one limited it to specific areas. This page controls which parts of it they are allowed to <strong>change</strong>. Enabling a permission here doesn't grant it to any existing token — each token also has to be created with the permission. Turning a permission off immediately blocks every token that carries it.
    </p>
    <form role="form" id="api-access-form">
      <div class="flex flex-col gap-y-md">
        <label v-for="capability in capabilities" :key="capability.key" class="flex">
          <input type="checkbox"
                 :name="capability.key"
                 :value="capability.key"
                 v-model="enabledCapabilities"
                 :aria-labelledby="`${capability.key}-label`"
                 :aria-describedby="`${capability.key}-description`">
          <div class="m-l-m flex flex-col">
            <span :id="`${capability.key}-label`" class="font-semi">
              {{ capability.label }}
            </span>
            <p :id="`${capability.key}-description`" class="font-normal m-b-none">
              {{ capability.description }}
            </p>
            <p class="font-normal text-14 text-gray-600 m-b-none m-t-xxs">
              <template v-if="tokenCountFor(capability.key) === 0">
                No active coach tokens currently hold this permission.
              </template>
              <template v-else>
                <strong>{{ tokenCountFor(capability.key) }}</strong> active coach {{ tokenCountFor(capability.key) === 1 ? 'token' : 'tokens' }} currently hold this permission and will lose it immediately if you turn it off.
              </template>
            </p>
          </div>
        </label>
      </div>

      <ladda-button @lbClicked="update" el-class="btn-primary m-t-md" :loading="updating">
        Save
      </ladda-button>
      <div v-if="error">
        <small><span class="text-danger">{{ errorMessage }}</span></small>
      </div>
    </form>
  </div>
</template>

<script>
import LaddaButton from '../../shared/ladda_button.vue';
import { API_WRITE_CAPABILITIES } from '../../shared/api_write_capabilities';
import { errorableMix } from './mixins/errorable_mix';

export default {
  name: 'api-access-settings',
  components: { LaddaButton },
  mixins: [errorableMix],
  props: {
    teamId: {
      type: Number,
      required: true,
    },
    initialCapabilities: {
      type: Array,
      required: true,
    },
    // Capability key -> count of active coach tokens holding that scope
    tokenCounts: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      capabilities: API_WRITE_CAPABILITIES,
      enabledCapabilities: [],
      updating: false,
    };
  },
  mounted() {
    this.enabledCapabilities = [...this.initialCapabilities];
  },
  methods: {
    tokenCountFor(key) {
      return this.tokenCounts[key] || 0;
    },
    update: _.throttle(function () {
      if (this.updating) {
        return;
      }

      const vm = this;
      vm.updating = true;
      vm.error = false;
      const url = vm.$apiService.teamUrl(this.teamId);
      const data = {
        team: {
          api_write_capabilities: this.enabledCapabilities,
        },
      };

      axios.put(url, data)
        .then(() => {
          vm.$notificationManager.emit('show-toast', 'API access settings saved', true);
          vm.updating = false;
        })
        .catch((error) => {
          vm.updating = false;
          vm.errorMessage = `Error: ${error.toString()}`;
          vm.error = true;
        });
    }, 500),
  },
};
</script>
